import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import LookupGeneric from "./lookupGeneric";
import IntentService from "../../src/Services/Intent.service";
const IntentLookup = (props) => {
    return LookupGeneric({
        onChange: props.onChange,
        defaultIds: props.defaultIds,
        labelKey: "description",
        valueKey: "id",
        fetchItemsById: (ids) => {
            return IntentService.findByIds(ids);
        },
        fetchOptions: (search) => {
            return IntentService.searchAll(search);
        },
        optionRenderer: function optionRenderer(intent) {
            return _jsx("span", { children: intent.description });
        },
    });
};
export default IntentLookup;
